module.exports = __webpack_public_path__ + "24_jov.jpg?7abca0aacbb16e3021d1581f4cd98489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_jov.jpg
// module id = 208
// module chunks = 0